import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  defineProps,
  defineEmits,
  getCurrentInstance,
  defineExpose,
  nextTick,
} from "../../../adapter-vue";
import {
  TUIGlobal,
  IConversationModel,
  TUIStore,
  StoreName,
  TUITranslateService,
  TUIConversationService,
} from "@tencentcloud/chat-uikit-engine";
import { CONV_OPERATION } from "../../../constant";
import Icon from "../../common/Icon.vue";
import muteIcon from "../../../assets/icon/mute.svg";
import { log } from "console";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  displayOnlineStatus: {
    type: Boolean,
    default: false,
  },
},
  emits: ["handleSwitchConversation"],
  setup(__props, { expose, emit: emits }) {

const props = __props




const list = ref();
const dialog = ref();
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
const isPC = ref(TUIGlobal.getPlatform() === "pc");
const isApp = ref(TUIGlobal.getPlatform() === "app");
const isWeChat = ref(TUIGlobal.getPlatform() === "wechat");
const isUniFrameWork = ref(typeof uni !== 'undefined');
const toggleID = ref("");
const currentConversation = ref<IConversationModel>();
const currentConversationID = ref("");
const conversationList = ref();
const listRectInfo = ref();
const toggleNowRectInfo = ref();
const dialogTop = ref(30);
const isLongpressing = ref(false);

TUIStore.watch(StoreName.CONV, {
  currentConversationID: (id: string) => {
    currentConversationID.value = id;
  },
  conversationList: (list: Array<IConversationModel>) => {
    conversationList.value = list;
  },
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const handleItem = (params: {
  name: any;
  conversation: IConversationModel;
}) => {
  const { name, conversation } = params;
  if (!name || !conversation || !conversation.conversationID) {
    return;
  }
  const conversationModel = conversationList.value?.find(
    (item: IConversationModel) => {
      return item.conversationID === conversation.conversationID;
    }
  );
  toggleID.value = "";
  switch (name) {
    case CONV_OPERATION.DELETE:
      conversationModel?.deleteConversation();
      break;
    case CONV_OPERATION.ISPINNED:
      conversationModel?.pinConversation();
      break;
    case CONV_OPERATION.DISPINNED:
      conversationModel?.pinConversation();
      break;
    case CONV_OPERATION.MUTE:
      conversationModel?.muteConversation();
      break;
    case CONV_OPERATION.NOTMUTE:
      conversationModel?.muteConversation();
      break;
  }
};

const handleToggleListItem = (
  e: any,
  conversation: IConversationModel,
  index: number,
  isLongpress = false
) => {
  if (isLongpress) {
    isLongpressing.value = true;
  }
  setToggleNowRectInfo(e.target);
  handleDialogPosition(conversation, index);
  nextTick(() => {
    onClickOutside(dialog.value);
  });
  // uniapp to wechat, click event doesn't working, use click.right instead click to switchConversation
  if (isWeChat.value) {
    handleSwitchConversation(conversation.conversationID);
  }
};

const closeToggleListItem = () => {
  toggleID.value && (toggleID.value = "");
};

const scrollChange = () => {
  toggleID.value && (toggleID.value = "");
};

// h5 long press
let timer: number;
const handleH5LongPress = (
  e: any,
  conversation: IConversationModel,
  index: number,
  type: string
) => {
  if (isPC.value) return;
  function longPressHandler() {
    clearTimeout(timer);
    handleToggleListItem(e, conversation, index, true);
  }
  function touchStartHandler() {
    timer = setTimeout(longPressHandler, 500);
  }
  function touchEndHandler() {
    clearTimeout(timer);
  }
  switch (type) {
    case "touchstart":
      touchStartHandler();
      break;
    case "touchend":
      touchEndHandler();
      setTimeout(() => {
        isLongpressing.value = false;
      }, 200);
      break;
  }
};

// handle toggle dialog position in view end
const handleDialogPosition = (
  conversation: IConversationModel,
  index: number
) => {
  dialogTop.value = 30;
  // 以下是神奇的 uniapp 的大大大大大坑！！！！
  if (isWeChat.value) {
    // wechat：无法使用ref获取dom信息，无法使用uni.createSelectorQuery获取非自定义component外的dom信息，无法使用getElement获取dom信息
    // 所以，wechat部分获取当前整个conversationList 宽高距离 以及获取当前toggle的元素的宽高距离采用的方案为：
    // 通过点击事件，获取e.target拿到toggle位置信息。在外层自定义组件中，对整个自定义组件通过uni.createSelectorQuery拿到整个conversationList信息
    if (listRectInfo?.value?.bottom - toggleNowRectInfo?.value?.y <= 100) {
      dialogTop.value = -70;
    }
    toggleID.value = conversation.conversationID;
  } else if (isApp.value) {
    // uniapp打包为native：无法使用ref获取dom信息，可以使用uni.createSelectorQuery获取dom信息
    // 所以，native部分获取当前整个conversationList 宽高距离 以及获取当前 toggle 的元素的宽高距离采用的方案为：
    // 通过uni.createSelectorQuery，拿到当前toggle的元素的宽高距离以及整个 conversationList 宽高距离
    // uni这个api还是异步的，奇慢无比，还要等他拿到再去显示dialog
    let listRect: any, toggleRect: any;
    const query = (uni as any)?.createSelectorQuery();
    query
      .select(".TUI-conversation-list")
      .boundingClientRect((data: any) => {
        listRect = data;
      })
      .exec();
    query
      .selectAll(".TUI-conversation-content")
      .boundingClientRect((data: any) => {
        toggleRect = data[index];
        if (listRect?.bottom - toggleRect?.top - 30 <= 100) {
          dialogTop.value = -70;
        }
        toggleID.value = conversation.conversationID;
      })
      .exec();
  } else {
    // web/h5/uniapp打包h5: 正常使用ref即可
    if (!list?.value?.children || index >= list?.value?.children?.length) {
      return;
    }
    const dom = list?.value?.children[index];
    const domRect = dom.getBoundingClientRect();
    const listRect = list?.value?.getBoundingClientRect();
    if (listRect?.bottom - domRect?.top - 30 <= 100) {
      dialogTop.value = isH5.value ? -70 : -50;
    }
    toggleID.value = conversation.conversationID;
  }
};

const setToggleNowRectInfo = (info: object) => {
  toggleNowRectInfo.value = info;
};

const setListRectInfo = (info: object) => {
  listRectInfo.value = info;
};

const handleSwitchConversation = (conversationID: string) => {
  console.log('conversationID',conversationID)
  console.log('conversationID',isLongpressing.value)
  if (isLongpressing.value || toggleID.value) {
    return;
  }
 
  emits("handleSwitchConversation", conversationID);
  TUIConversationService.switchConversation(conversationID);
};

// web: on click outside
// web 支持整个页面维度 on click outside
// uniapp 支持整个 TUIConversation 组件维度 on click outside
const onClickOutside = (component: any) => {
  if (isUniFrameWork.value) {
    return;
  }
  document.addEventListener("mousedown", onClickDocument);
};

const onClickDocument = (e: any) => {
  if (e?.target?.className?.includes("conversation-options")) {
    return;
  }else{
    closeToggleListItem();
    removeClickListener();
  }
};

const removeClickListener = () => {
  if (isUniFrameWork.value) {
    return;
  }
  document.removeEventListener("mousedown", onClickDocument);
};

expose({ setListRectInfo,handleSwitchConversation });


 //defineExpose({  });

return { __sfc: true,props, emits, list, dialog, isH5, isPC, isApp, isWeChat, isUniFrameWork, toggleID, currentConversation, currentConversationID, conversationList, listRectInfo, toggleNowRectInfo, dialogTop, isLongpressing, handleItem, handleToggleListItem, closeToggleListItem, scrollChange, timer, handleH5LongPress, handleDialogPosition, setToggleNowRectInfo, setListRectInfo, handleSwitchConversation, onClickOutside, onClickDocument, removeClickListener, TUITranslateService, CONV_OPERATION, Icon, muteIcon }
}

})